import { animate, group, query, style, transition, trigger } from '@angular/animations';

const back = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%', height: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(-100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(100%)' }))], {
      optional: true,
    }),
  ]),
];

const forward = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%', height: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(100%)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(-100%)' }))], {
      optional: true,
    }),
  ]),
];

export const slideInOutAnimation = trigger('routeAnimations', [
  transition('MobileNumberPage => PersonPage', forward),
  transition('PersonPage => MobileNumberPage', back),

  transition('PersonPage => ResidencePage', forward),
  transition('ResidencePage => PersonPage', back),

  transition('ResidencePage => NationalityPage', forward),
  transition('NationalityPage => ResidencePage', back),

  transition('NationalityPage => BankAccountPage', forward),
  transition('BankAccountPage => NationalityPage', back),

  transition('BankAccountPage => InitialDepositPage', forward),
  transition('InitialDepositPage => BankAccountPage', back),

  transition('InitialDepositPage => ProvisionPage', forward),
  transition('ProvisionPage => InitialDepositPage', back),

  transition('ProvisionPage => IdentPage', forward),
  transition('IdentPage => ProvisionPage', back),

  transition('IdentPage => InProgressPage', forward),
  transition('InProgressPage => IdentPage', back),

  transition('InProgressPage => FavoriteSuggestionsPage', forward),
  transition('FavoriteSuggestionsPage => InProgressPage', back),

  transition('FavoriteSuggestionsPage => Top3IssuerPage', forward),
  transition('Top3IssuerPage => FavoriteSuggestionsPage', back),

  transition('FavoriteSuggestionsPage => SavingsPlanAlternativePage', forward),
  transition('SavingsPlanAlternativePage => FavoriteSuggestionsPage', back),

  transition('SavingsPlanAlternativePage => SavingsPlanCreatePage', forward),
  transition('SavingsPlanCreatePage => SavingsPlanAlternativePage', back),

  transition('Top3IssuerPage => SavingsPlanCreatePage', forward),
  transition('SavingsPlanCreatePage => Top3IssuerPage', back),

  transition('SavingsPlanCreatePage => SavingsPlanConfirmPage', forward),
  transition('SavingsPlanConfirmPage => SavingsPlanCreatePage', back),

  transition('SavingsPlanConfirmPage => SavingsPlanSuccessPage', forward),

  transition('InProgressPage => InvestmentStrategyChoicePage', forward),
  transition('InvestmentStrategyChoicePage => InProgressPage', back),

  transition('InvestmentStrategyChoicePage => InvestmentStrategySuccessPage', forward),
  transition('InvestmentStrategySuccessPage => InvestmentStrategyChoicePage', back),
]);
